import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledBannerImage = styled.div`
  color: ${t => t.theme.blue};
  text-transform: uppercase;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 20rem;
  padding: 2rem;
  background-color: #ccc;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  box-sizing: border-box;

  h1 {
    color: white;
    background: ${t => t.theme.blue};
    display: block;
    padding: 0 2.5rem;
    font-size: 2rem;
    font-weight: bold;
  }

  @media (min-width: 500px) {
    h1 {
      font-size: 3rem;
    }
  }
`;

const propTypes = {
  title: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: null,
};

function BannerImage({ className, img, title }) {
  return (
    <StyledBannerImage className={className} style={{ backgroundImage: `url(${img})` }}>
      <h1>
        {title}
      </h1>
    </StyledBannerImage>
  );
}

BannerImage.propTypes = propTypes;
BannerImage.defaultProps = defaultProps;

export default BannerImage;



// WEBPACK FOOTER //
// ./src/Components/BannerImage/index.jsx